/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { motion, useSpring, useTransform, useInView, AnimatePresence, cubicBezier, useAnimate, stagger } from 'framer-motion';
import { useRef, useState, useEffect, useContext } from 'react';
import { useInViewScroll, MotionImage, useSanitizedTranslation, PromoBlock, XumoButton as Button, StackedContent, TextBlock } from 'ui';
import Image from 'next/image';

export interface Img {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export interface TwoColTxtImgProps {
  content: any;
  flipped: boolean;
  rounded: boolean;
  image: Img[];
  imgpadding?: string;
  bg: string;
  textPadding: string;
  textWidth: string;
}

export const TwoColTxtImg = ({
  content,
  image,
  flipped,
  imgpadding,
  bg = 'white',
  rounded = false,
  textPadding = '10',
  textWidth = 'w-full',
}: TwoColTxtImgProps) => {
  return (
    <motion.section className={`${bg}`} data-testid={'text-section'}>
      <div
        className={`wrapper items-center justify-center gap-8 ${flipped ? 'flex-col-reverse lg:flex-row-reverse' : 'flex-col lg:flex-row'} flex h-full
      w-full py-12 lg:pb-32 lg:pt-10`}
      >
        <div className={`h-full w-full px-${textPadding} lg:p-0`}>
          <div className={`${textWidth}`}>
            <StackedContent left content={content} />
          </div>
        </div>
        <div className={`h-max w-full ${rounded ? 'overflow-clip rounded-2xl' : ''}`}>
          <Image
            src={image.src}
            alt={image.alt || ''}
            className="h-auto w-full"
            style={{
              padding: imgpadding ? imgpadding : 0,
            }}
            width={image?.width ?? 1300}
            height={image?.height ?? 828}
          />
        </div>
      </div>
    </motion.section>
  );
};
